import React from 'react'
import ContactPersonList from '../../features/marketingExecutive/ContactPersonList'

const ConstactPersonListPage = () => {
  return <ContactPersonList/>
}

export default ConstactPersonListPage